// src/api/useDeleteTA.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const deleteTA = async (taId) => {
  return api.delete(`/admin/ta/${taId}`);
};

export const useDeleteTAQuery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTA,
    onSuccess: () => {
      // 성공 시 TAs 쿼리 데이터를 무효화하여 최신 상태로 갱신합니다.
      queryClient.invalidateQueries(["TAs"]);
    },
  });
};
